import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AscReportService } from '../../services/asc-report.service';
import { AuthService } from '../../../services/auth.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-asc-alertperiod',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './asc-alertperiod.html',
  styleUrls: ['./asc-alertperiod.scss']
})
export class AscAlertperiodComponent implements OnInit {
  @Output() navigateToJobOrder = new EventEmitter<number>();
  @Output() navigateToAsc = new EventEmitter<any>();
  @Output() navigateToCustomer = new EventEmitter<number>();
  @Output() transferToProcessing = new EventEmitter<any>();

  unprocessedAlerts: any[] = [];
  processedAlerts: any[] = [];
  otherAlerts: any[] = [];
  selectedPeriod = 'today';
  otherAlertsPeriod = 'today';

  // 詳細ブロック
  showUnprocessedBlock = true;
  showDetailBlock = false;
  selectedAlert: any = null;
  editStartDate = '';
  editEndDate = '';
  showMemo = false;

  // ページング（未処理）
  unprocessedPageNo: number = 1;
  unprocessedPageSize: number = 50;
  unprocessedTotalRecords: number = 0;
  unprocessedTotalPages: number = 0;

  // ページング（処理済）
  processedPageNo: number = 1;
  processedPageSize: number = 20;
  processedTotalRecords: number = 0;
  processedTotalPages: number = 0;

  // ページング（その他のアラート）
  otherAlertsPageNo: number = 1;
  otherAlertsPageSize: number = 20;
  otherAlertsTotalRecords: number = 0;
  otherAlertsTotalPages: number = 0;

  // その他のアラート
  otherAlertsStatus = 'unprocessed';

  constructor(
    private ascReportService: AscReportService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loadUnprocessedAlerts();
    this.loadProcessedAlerts();
    this.loadOtherAlerts();
  }

  async loadUnprocessedAlerts() {
    try {
      const response = await firstValueFrom(this.ascReportService.getUnprocessedWorkPeriodAlerts(this.unprocessedPageNo, this.unprocessedPageSize));
      
      if (response?.status && response.data) {
        this.unprocessedAlerts = response.data.alerts || [];
        this.unprocessedTotalRecords = response.data.totalRecords || 0;
        this.unprocessedTotalPages = Math.ceil(this.unprocessedTotalRecords / this.unprocessedPageSize);
        
        // BPchkが未定義またはnullの場合は0に初期化
        this.unprocessedAlerts.forEach(alert => {
          if (alert.bpchk === null || alert.bpchk === undefined) {
            alert.bpchk = 0;
          }
        });
      }
    } catch (error) {
      console.error('未処理アラート取得エラー:', error);
      window.alert('未処理アラート一覧の取得に失敗しました');
    }
  }

  async loadProcessedAlerts() {
    try {
      const response = await firstValueFrom(this.ascReportService.getProcessedWorkPeriodAlerts(this.selectedPeriod, this.processedPageNo, this.processedPageSize));
      if (response?.status && response.data) {
        this.processedAlerts = response.data.alerts || [];
        this.processedTotalRecords = response.data.totalRecords || 0;
        this.processedTotalPages = Math.ceil(this.processedTotalRecords / this.processedPageSize);
      }
    } catch (error) {
      console.error('処理済みアラート取得エラー:', error);
      window.alert('処理済みアラート一覧の取得に失敗しました');
    }
  }

  onPeriodChange(period: string) {
    this.selectedPeriod = period;
    this.processedPageNo = 1;
    this.loadProcessedAlerts();
  }

  async saveMemo(alert: any) {
    try {
      const userId = this.authService.getUserId();
      const request = {
        odchgID: alert.odchgID,
        procComment: alert.procComment ?? '',
        bpchk: alert.bpchk || 0,
        userID: userId ?? 0
      };

      const response = await firstValueFrom(this.ascReportService.saveProcComment(request));
      if (response?.status === true || response?.data === true) {
        // リスト内の対応レコードも同期して更新（再取得不要）
        const listItem = this.unprocessedAlerts.find(a => a.odchgID === alert.odchgID);
        if (listItem) {
          listItem.procComment = alert.procComment ?? '';
          listItem.bpchk = alert.bpchk || 0;
        }
        window.alert('メモを保存しました');
      } else {
        window.alert('メモ保存に失敗しました: ' + (response?.message ?? '不明なエラー'));
      }
    } catch (error: any) {
      console.error('メモ保存エラー:', error);
      const status = error?.status;
      if (status === 401) {
        window.alert('認証エラーです。再ログインしてください。');
      } else if (status === 403) {
        window.alert('この操作の権限がありません。');
      } else {
        window.alert('メモ保存エラーが発生しました: ' + (error?.message ?? '不明なエラー'));
      }
    }
  }

  onBPchkChange(alert: any, event: any) {
    // BP確認チェックボックスの変更処理（画面表示のみ、保存はしない）
    const isChecked = event.target.checked;
    alert.bpchk = isChecked ? 1 : 0;
  }

  async executeAlternative(alert: any) {
    console.log('=== executeAlternative メソッドが呼ばれました ===');
    console.log('alert オブジェクト:', alert);
    
    if (!confirm('別処理を実行しますか？')) {
      return;
    }
    
    try {
      const userId = this.authService.getUserId();
      const request = {
        odchgID: alert.odchgID,
        userID: userId ?? 0
      };
      
      console.log('別処理リクエスト:', request);
      console.log('alert.odchgID:', alert.odchgID);
      console.log('userId:', userId);
      
      const response = await firstValueFrom(this.ascReportService.executeAlternativeProcess(request));
      console.log('別処理レスポンス:', response);
      
      if (response?.status && response.data) {
        const result = response.data;
        
        if (result.isSuccess === false || result.isSuccess === 0) {
          // 失敗時はChangeTypeTextを表示
          window.alert(result.changeTypeText || '別処理の実行に失敗しました');
        } else if (result.isSuccess === true || result.isSuccess === 1) {
          // 成功時（メールはバックエンドで送信済み）
          window.alert('別処理を実行しました');
          
          // リストを再読み込み
          await this.loadUnprocessedAlerts();
          await this.loadProcessedAlerts();
          this.onCloseDetail();
        }
      } else {
        window.alert('別処理の実行に失敗しました');
      }
    } catch (error) {
      console.error('別処理実行エラー:', error);
      window.alert('別処理の実行に失敗しました');
    }
  }

  /** 修正期間の入力値が正しい日付かどうかを検証する */
  onEditDateChange(field: 'start' | 'end'): void {
    const value = field === 'start' ? this.editStartDate : this.editEndDate;
    if (!value) return;
    if (!this.isValidDate(value)) {
      window.alert(`修正期間の${field === 'start' ? '開始日' : '終了日'}の日付が正しくありません: "${value}"\n正しい形式（例: 2025/4/1）で入力してください。`);
    }
  }

  /** yyyy/M/d または yyyy/MM/dd 形式の文字列が有効な日付かどうかを返す */
  private isValidDate(value: string): boolean {
    // スラッシュ区切りで 3 要素に分解
    const parts = value.split('/');
    if (parts.length !== 3) return false;
    const [y, m, d] = parts.map(Number);
    if (!y || !m || !d || isNaN(y) || isNaN(m) || isNaN(d)) return false;
    const date = new Date(y, m - 1, d);
    return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
  }

  async deleteTimesheet(alert: any) {
    // 修正期間の日付が正しい形式かチェック
    if (this.editStartDate && !this.isValidDate(this.editStartDate)) {
      window.alert(`修正期間の開始日の日付が正しくありません: "${this.editStartDate}"`);
      return;
    }
    if (this.editEndDate && !this.isValidDate(this.editEndDate)) {
      window.alert(`修正期間の終了日の日付が正しくありません: "${this.editEndDate}"`);
      return;
    }
    // 開始日と終了日の逆転チェック
    if (this.editStartDate && this.editEndDate) {
      const start = new Date(this.editStartDate.replace(/\//g, '-'));
      const end   = new Date(this.editEndDate.replace(/\//g, '-'));
      if (start > end) {
        window.alert(`修正期間の開始日（${this.editStartDate}）が終了日（${this.editEndDate}）より後になっています。\n開始日と終了日を確認してください。`);
        return;
      }
    }
    // 修正期間がDTStartDate～DTEndDateを完全に包含する場合（期間拡張）はエラー
    const dtStart = alert.dtStartDate ? new Date(alert.dtStartDate.replace(/\//g, '-')) : null;
    const dtEnd   = alert.dtEndDate   ? new Date(alert.dtEndDate.replace(/\//g, '-'))   : null;

    if (dtStart && dtEnd && this.editStartDate && this.editEndDate) {
      const editStart = new Date(this.editStartDate.replace(/\//g, '-'));
      const editEnd   = new Date(this.editEndDate.replace(/\//g, '-'));
      if (editStart < dtStart && editEnd > dtEnd) {
        window.alert('期間を広げる場合はPBの獲注情報を修正してください。');
        return;
      }
    }
    
    if (!confirm('獲注の契約期間に合わせてタイムシートを削除します。よろしいですか？')) {
      return;
    }
    
    try {
      const userId = this.authService.getUserId();

      // 日付を ISO 8601（yyyy-MM-dd）形式に変換してから送信
      // （APIレスポンスは "yyyy/M/d" 形式で返るが、System.Text.Json は ISO 8601 のみ受け付ける）
      const toIso = (d: string) => {
        if (!d) return undefined;
        const parts = d.split('/');
        if (parts.length !== 3) return undefined;
        const [y, m, dd] = parts;
        return `${y}-${m.padStart(2, '0')}-${dd.padStart(2, '0')}`;
      };

      const request = {
        odchgID: alert.odchgID,
        procUserID: userId ?? 0,
        editStartDate: toIso(this.editStartDate),
        editEndDate: toIso(this.editEndDate)
      };
      
      const response = await firstValueFrom(this.ascReportService.deleteTimesheetForAlert(request));
      console.log('[TS削除] response:', response);
      
      if (response?.data) {
        const result = response.data;
        console.log('[TS削除] result:', result);
        
        if (!result.isSuccess) {
          // 失敗時はSPのChangeTypeText（失敗理由）を表示
          console.warn('[TS削除] isSuccess=false, changeTypeText:', result.changeTypeText);
          window.alert(result.changeTypeText || 'タイムシート削除処理に失敗しました');
        } else {
          // 成功時（メールはバックエンドで送信済み）
          window.alert('タイムシート削除処理が完了しました');
          
          // リストを再読み込み
          await this.loadUnprocessedAlerts();
          await this.loadProcessedAlerts();
          this.onCloseDetail();
        }
      } else {
        window.alert('タイムシート削除処理に失敗しました');
      }
    } catch (error) {
      console.error('TS削除処理エラー:', error);
      window.alert('タイムシート削除処理中にエラーが発生しました');
    }
  }


  async completeProcess(alert: any) {
    if (!confirm('完了処理を実行しますか？')) {
      return;
    }
    
    try {
      const userId = this.authService.getUserId();
      const request = {
        odchgID: alert.odchgID,
        userID: userId ?? 0
      };
      
      const response = await firstValueFrom(this.ascReportService.completeProcess(request));
      if (response?.status) {
        window.alert('完了処理を実行しました');
        
        await this.loadUnprocessedAlerts();
        await this.loadProcessedAlerts();
        this.onCloseDetail();
      } else {
        window.alert('完了処理の実行に失敗しました');
      }
    } catch (error) {
      console.error('完了処理エラー:', error);
      window.alert('完了処理の実行に失敗しました');
    }
  }

  async rejectProcess(alert: any) {
    if (!confirm('この処理を差戻しますか？')) {
      return;
    }
    
    try {
      const userId = this.authService.getUserId();
      const request = {
        odchgID: alert.odchgID,
        userID: userId ?? 0
      };
      
      const response = await firstValueFrom(this.ascReportService.rejectProcess(request));
      if (response?.status) {
        window.alert('差戻しを実行しました');
        await this.loadUnprocessedAlerts();
        await this.loadProcessedAlerts();
      } else {
        window.alert('差戻しの実行に失敗しました');
      }
    } catch (error) {
      console.error('差戻し処理エラー:', error);
      window.alert('差戻しの実行に失敗しました');
    }
  }

  exportProcessedAlertsToCSV() {
    if (this.processedAlerts.length === 0) {
      alert('出力するデータがありません');
      return;
    }

    const headers = [
      '獲注番号', 'スタッフ番号', '部署コード', 
      '元開始日', '元終了日', '新開始日', '新終了日', 
      '発生日', '状態', '前払い', '支店担当者', 
      'メール送信日時', '処理者', '処理日時', '処理', 'メモ'
    ];

    const csvData = this.processedAlerts.map(alert => [
      alert.jobOrderID,
      alert.userCode || '',
      alert.customerOfficeCode || '',
      alert.oldStartDate || '',
      alert.oldEndDate || '',
      alert.newStartDate || '',
      alert.newEndDate || '',
      alert.createDate || '',
      alert.dataState || '',
      alert.prePay || '',
      alert.alertSentTo || '',
      alert.alertSentDate || '',
      alert.procUserName || '',
      alert.procDate || '',
      alert.procStatus || '',
      alert.procComment || ''
    ]);

    const csvContent = [headers, ...csvData]
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');

    const bom = '\uFEFF';
    const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `processed_alerts_${new Date().getTime()}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onShowDetail(alert: any) {
    this.selectedAlert = { ...alert };
    this.editStartDate = alert.newStartDate || '';
    this.editEndDate = alert.newEndDate || '';
    this.showUnprocessedBlock = false;
    this.showDetailBlock = true;
  }

  onCloseDetail() {
    this.showDetailBlock = false;
    this.showUnprocessedBlock = true;
    this.selectedAlert = null;
  }

  onDetailBPchkChange(event: any) {
    if (this.selectedAlert) {
      this.selectedAlert.bpchk = event.target.checked ? 1 : 0;
    }
  }

  toggleMemo() {
    this.showMemo = !this.showMemo;
  }

  async saveSelectedMemo() {
    if (this.selectedAlert) {
      await this.saveMemo(this.selectedAlert);
    }
  }

  getAlertStatusDescription(): string {
    const descriptions: { [key: string]: string } = {
      '0_未更新': '削除可能な状態です',
      '1_保存': 'タイムシートが保存されています',
      '2_提出': 'タイムシートが提出されています',
      '3_承認': 'タイムシートが承認されています',
    };
    return descriptions[this.selectedAlert?.dataState] || '';
  }

  navigateToJobOrderInfo(jobOrderId: number) {
    this.navigateToJobOrder.emit(jobOrderId);
  }

  navigateToAscInfo(data: any) {
    this.navigateToAsc.emit(data);
  }

  navigateToCustomerInfo(customerOfficeId: number) {
    this.navigateToCustomer.emit(customerOfficeId);
  }

  // 現獲注番号と新獲注番号が異なる場合のみ遷移リンクを有効化
  canNavigateCurrentJobOrder(alert: any): boolean {
    if (!alert) return false;

    const currentId = Number(alert.jobOrderID);
    const newId = Number(alert.newJobOrderID);

    if (Number.isNaN(currentId) || Number.isNaN(newId)) {
      return false;
    }

    return currentId !== newId;
  }

  // ページ変更（未処理）
  onUnprocessedPageChange(pageNo: number): void {
    if (pageNo < 1 || pageNo > this.unprocessedTotalPages) {
      return;
    }
    this.unprocessedPageNo = pageNo;
    this.loadUnprocessedAlerts();
  }

  // ページ番号配列を取得（未処理）
  getUnprocessedPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisible = 10;
    
    if (this.unprocessedTotalPages <= maxVisible) {
      for (let i = 1; i <= this.unprocessedTotalPages; i++) {
        pages.push(i);
      }
    } else {
      const half = Math.floor(maxVisible / 2);
      let start = Math.max(1, this.unprocessedPageNo - half);
      let end = Math.min(this.unprocessedTotalPages, start + maxVisible - 1);
      
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  }

  // ページ変更（処理済）
  onProcessedPageChange(pageNo: number): void {
    if (pageNo < 1 || pageNo > this.processedTotalPages) {
      return;
    }
    this.processedPageNo = pageNo;
    this.loadProcessedAlerts();
  }

  // ページ番号配列を取得（処理済）
  getProcessedPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisible = 10;
    
    if (this.processedTotalPages <= maxVisible) {
      for (let i = 1; i <= this.processedTotalPages; i++) {
        pages.push(i);
      }
    } else {
      const half = Math.floor(maxVisible / 2);
      let start = Math.max(1, this.processedPageNo - half);
      let end = Math.min(this.processedTotalPages, start + maxVisible - 1);
      
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  }

  // その他のアラートリスト読み込み
  async loadOtherAlerts() {
    try {
      const response = await firstValueFrom(this.ascReportService.getOtherAlerts(this.otherAlertsPeriod, this.otherAlertsStatus, this.otherAlertsPageNo, this.otherAlertsPageSize));
      if (response?.status && response.data) {
        this.otherAlerts = response.data.alerts || [];
        this.otherAlertsTotalRecords = response.data.totalRecords || 0;
        this.otherAlertsTotalPages = Math.ceil(this.otherAlertsTotalRecords / this.otherAlertsPageSize);
      }
    } catch (error) {
      console.error('その他のアラート取得エラー:', error);
      alert('その他のアラート一覧の取得に失敗しました');
    }
  }

  // その他のアラートリスト期間変更
  onOtherAlertsPeriodChange(period: string) {
    this.otherAlertsPeriod = period;
    this.otherAlertsPageNo = 1;
    this.loadOtherAlerts();
  }

  // その他のアラートリストステータス変更
  onOtherAlertsStatusChange(status: string) {
    this.otherAlertsStatus = status;
    this.otherAlertsPageNo = 1;
    this.loadOtherAlerts();
  }

  // その他のアラートリストページ変更
  onOtherAlertsPageChange(pageNo: number) {
    if (pageNo < 1 || pageNo > this.otherAlertsTotalPages) {
      return;
    }
    this.otherAlertsPageNo = pageNo;
    this.loadOtherAlerts();
  }

  // その他のアラートリストページ番号配列を取得
  getOtherAlertsPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisible = 10;
    
    if (this.otherAlertsTotalPages <= maxVisible) {
      for (let i = 1; i <= this.otherAlertsTotalPages; i++) {
        pages.push(i);
      }
    } else {
      const half = Math.floor(maxVisible / 2);
      let start = Math.max(1, this.otherAlertsPageNo - half);
      let end = Math.min(this.otherAlertsTotalPages, start + maxVisible - 1);
      
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  }

  // その他のアラートリストCSV出力
  async exportOtherAlertsToCSV() {
    try {
      const response = await firstValueFrom(this.ascReportService.getOtherAlerts(this.otherAlertsPeriod, this.otherAlertsStatus, 1, 100000));
      if (!response?.status || !response.data?.alerts) {
        alert('データの取得に失敗しました');
        return;
      }

      const alerts = response.data.alerts;
      if (alerts.length === 0) {
        alert('出力するデータがありません');
        return;
      }

      const headers = ['AID', '現獲注番号', '新獲注番号', 'スタッフ番号', '部署コード', 'エラー内容', 'メール送信日時', '支店担当者'];
      const csvContent = [
        headers.join(','),
        ...alerts.map((alert: any) => [
          alert.odchgID || '',
          alert.jobOrderID || '',
          alert.newJobOrderID || '',
          alert.staffCode || '',
          alert.clientCode || '',
          `"${(alert.procComment || '').replace(/"/g, '""')}"`,
          alert.sendDate || '',
          alert.repName || ''
        ].join(','))
      ].join('\n');

      const bom = '\uFEFF';
      const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `その他のアラートリスト_${new Date().toISOString().slice(0, 10)}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('CSV出力エラー:', error);
      alert('CSV出力に失敗しました');
    }
  }

  // 転記処理タブに遷移
  navigateToTransfer(odchgId: number): void {
    this.transferToProcessing.emit({ oDchgID: odchgId });
  }

  // 完了処理（未処理アラート一覧の再読込も行う）
  async confirmProcess(alert: any) {
    try {
      const userId = this.authService.getUserId();
      const request = {
        odchgID: alert.odchgID,
        userID: userId ?? 0
      };

      const response = await firstValueFrom(this.ascReportService.completeProcess(request));

      if (response?.status) {
      // 必要な一覧を再読込
        await this.loadOtherAlerts();
        await this.loadProcessedAlerts();
        await this.loadUnprocessedAlerts();
      }
    } catch (error) {
      console.error('完了更新エラー:', error);
      window.alert('完了更新に失敗しました');
    }
  }
}
